import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { registerServiceWorker } from "./lib/offline";
// Skriftene først: de er nå våre egne, ikke Googles. Se scripts/download-fonts.mjs.
import "./fonts.css";
import "./styles.css";
import "./components.css";

const container = document.getElementById("root");
if (!container) throw new Error("Fant ikke #root i index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Gjør appen brukbar uten dekning — det er ikke mobilnett på Hardangervidda.
registerServiceWorker();
